/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { ActionHintEnumType } from './ActionHintEnum'
import { BetModel, BetModelType } from './BetModel'
import { BetModelSelector } from './BetModel.base'
import { GameStateModel, GameStateModelType } from './GameStateModel'
import { GameStateModelSelector } from './GameStateModel.base'
import { RootStoreType } from './index'

/**
 * GameSnapshotBase
 * auto generated base class for the model GameSnapshotModel.
 */
export const GameSnapshotModelBase = ModelBase.named('GameSnapshot')
  .props({
    __typename: types.optional(types.literal('GameSnapshot'), 'GameSnapshot'),
    currentPlayerAction: types.union(types.undefined, types.null, types.array(ActionHintEnumType)),
    eventsToBroadcastAfterSleepIds: types.union(types.undefined, types.null, types.array(types.string)),
    forPlayer: types.union(types.undefined, types.null, types.frozen()),
    gameId: types.union(types.undefined, types.string),
    gameName: types.union(types.undefined, types.string),
    gameState: types.union(
      types.undefined,
      types.late(() => GameStateModel)
    ),
    kind: types.union(types.undefined, types.null, types.string),
    leftPlayers: types.union(types.undefined, types.null, types.frozen()),
    players: types.union(types.undefined, types.null, types.frozen()),
    table: types.union(types.undefined, types.frozen()),
    withBet: types.union(
      types.undefined,
      types.null,
      types.late(() => BetModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class GameSnapshotModelSelector extends QueryBuilder {
  get currentPlayerAction() {
    return this.__attr('currentPlayerAction')
  }
  get eventsToBroadcastAfterSleepIds() {
    return this.__attr('eventsToBroadcastAfterSleepIds')
  }
  get forPlayer() {
    return this.__attr('forPlayer')
  }
  get gameId() {
    return this.__attr('gameId')
  }
  get gameName() {
    return this.__attr('gameName')
  }
  get kind() {
    return this.__attr('kind')
  }
  get leftPlayers() {
    return this.__attr('leftPlayers')
  }
  get players() {
    return this.__attr('players')
  }
  get table() {
    return this.__attr('table')
  }
  gameState(
    builder:
      | string
      | GameStateModelSelector
      | ((selector: GameStateModelSelector) => GameStateModelSelector)
      | undefined
  ) {
    return this.__child('gameState', GameStateModelSelector, builder)
  }
  withBet(builder: string | BetModelSelector | ((selector: BetModelSelector) => BetModelSelector) | undefined) {
    return this.__child('withBet', BetModelSelector, builder)
  }
}
export function selectFromGameSnapshot() {
  return new GameSnapshotModelSelector()
}

export const gameSnapshotModelPrimitives =
  selectFromGameSnapshot().currentPlayerAction.eventsToBroadcastAfterSleepIds.forPlayer.gameId.gameName.kind.leftPlayers
    .players.table
